import { buttonReset } from 'components/Button/Button.styles'
import { styled } from 'stitches.config'

export const PostsListRoot = styled('div', {
  display: 'grid',
  gridGap: '$4',
  gridTemplateColumns: 'repeat(auto-fill, 377px)',
  placeContent: 'center',
  paddingBottom: '$15',
})

export const Wrapper = styled('div', {
  margin: 'auto',
  backgroundColor: '$accent-white',
  px: '$3',

  '@bp2': {
    px: '$8',
  },
})

export const LoadMore = styled('button', buttonReset, {
  marginBottom: '$9',
  width: '100%',
  cursor: 'pointer',
})
